export default __webpack_public_path__ + "static/media/sidebar-canvas_darkGray3.93e1d2d4.svg";